export class DropDownList {
    label: string;
    value: number;
    set(item: any) {
        this.label = item.lable;
        this.value = item.value;
       
    }
}
